module.exports = __webpack_public_path__ + "img/1519635363.c70de2b9.jpg";